import styled from '@emotion/styled'
import { DialogTitle } from '@resiliatech/birdsong'
import { Popover as MuiPopover } from '@material-ui/core'

export const Popover = styled(MuiPopover)`
  .MuiPopover-paper {
    width: 100%;
    max-width: 600px;
  }
`

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
`

export const TitleSection = styled(DialogTitle)`
  padding: 0;
  display: flex;
  align-items: center;
  gap: 8px;
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 16px;
`
